import { HttpHeaders,HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../shared/services';
import { IGlobalSearchParam } from '../../shared/models/Global-Search.model';

import { environment } from '../../../environments/environment';
import { IClientApprovalNotes } from '../models';

@Injectable({
  providedIn: 'root'
})
export class ClientApprovalService {
    constructor(private http: HttpClient,
        private apiService: ApiService) { }
        public getAllClientApprovalList(userApprovalSearchParam:IGlobalSearchParam):Observable<any> {
            return this.apiService.post(`VendorClientAssignment/SearchClientApproval`,userApprovalSearchParam)
        }
        public rejectClient(assignId:number,loggedInUserId:number):Observable<any>{
          return this.apiService.get(`VendorClientAssignment/RejectClient?assignId=${assignId}&loggedInUserId=${loggedInUserId}`);
        }
        public approveClient(assignId:number,loggedInUserId:number):Observable<any>{
          return this.apiService.get(`VendorClientAssignment/ApproveClient?assignId=${assignId}&loggedInUserId=${loggedInUserId}`);
        }
        public updateClientNotes(clientNotes: IClientApprovalNotes):Observable<any>{
          return this.apiService.post(`VendorClientAssignment/UpdateClientNotes`,clientNotes);
        }
        public GetClientNotes(assignId: number,companyId:number,clientId:number):Observable<any>{
          return this.apiService.get(`VendorClientAssignment/GetClientNotes?assignId=${assignId}&companyId=${companyId}&clientId=${clientId}`);
        }
        public getApprovalStatus(approvalStatusId:number):Observable<any>{
          return this.apiService.get(`VendorClientAssignment/GetApprovalStatus?approvalStatusId=${approvalStatusId}`)
        }
}